export default __webpack_public_path__ + "locales/uk-UA/Ldap.json?hash=12aabdbf8a1f263f554fbfb5146a6a2a";